import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import CorporateActionEventsVM from './CorporateActionEventsVM';
import { observer } from 'mobx-react';
import Loading from '../../../App/Components/Loading/Loading';
import { TextConstants } from '../../../Common/TextConstants';
import CorporateActionEventLookup from '../Models/Lookups/CorporateActionEventLookup';
import ManageCorporateActionEventComponent from '../Components/ManageCorporateActionEventComponent';

@observer
export default class CorporateActionEventsView extends Views.ViewBase<CorporateActionEventsVM> {

    constructor(props: unknown) {
        super("Corporate Action Events", CorporateActionEventsVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showManageCorporateActionComponent === true &&
                    <>
                        <ManageCorporateActionEventComponent
                            viewModel={this.viewModel.manageCorporateActionEventVM}
                            onSave={() => this.viewModel.save()}
                            onCancel={() => this.viewModel.cancel()}
                        />
                    </>

                }
                <Neo.Modal
                    title={TextConstants.Buttons.CreateAsEvent}
                    bind={this.viewModel.meta.showDeleteConfirmModalInd}
                    size="lg"
                    closeButton={{ text: TextConstants.Buttons.No, variant: "primary", isOutline: true }}
                    acceptButton={{ text: TextConstants.Buttons.Yes, onClick: () => this.viewModel.deleteCorporateActionEvent()}}
                    >
                    {TextConstants.GeneralText.DeleteCorporateActionEvent}
                 </Neo.Modal>
                 <Neo.Modal
                    title={TextConstants.Buttons.CreateAsEvent}
                    bind={this.viewModel.meta.showCompleteConfirmModalInd}
                    size="lg"
                    closeButton={{ text: TextConstants.Buttons.No, variant: "primary", isOutline: true }}
                    acceptButton={{ text: TextConstants.Buttons.Yes, onClick: () => this.viewModel.completeCorporateActionEvent()}}
                    >
                    {TextConstants.GeneralText.CompleteCorporateActionEvent}
                 </Neo.Modal>
                {this.viewModel.showManageCorporateActionComponent === false &&
                    <>
                        <Neo.Card title={TextConstants.Titles.CorporateActionEvents} className="m-1">
                            <Neo.Form model={this.viewModel.corporateActionEventSearchCriteria} onSubmit={() => this.viewModel.corporateActionEventSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <div className="row">
                                    <div className="col-lg-3">
                                        <Neo.FormGroup bindContext={this.viewModel.corporateActionEventSearchCriteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                                bind={this.viewModel.corporateActionEventSearchCriteria.meta.staticServiceProviderFileGroupingID}
                                                bindDisplay={this.viewModel.corporateActionEventSearchCriteria.meta.serviceProviderGroupingName}
                                                displayMember={"serviceProviderGroupingName"}
                                                onItemSelected={() => this.viewModel.pageManager.refreshData()}
                                                items={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                                                .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName))
                                                )}
                                            />
                                        </Neo.FormGroup>
                                    </div>
                                    <div className="col-lg-3">
                                        <Neo.FormGroup bindContext={this.viewModel.corporateActionEventSearchCriteria.meta.status}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={this.viewModel.corporateActionEventsApiClient.getCorporateActionStatusListByCriteria}
                                                bind={this.viewModel.corporateActionEventSearchCriteria.meta.corporateActionStatusID}
                                                bindDisplay={this.viewModel.corporateActionEventSearchCriteria.meta.status}
                                                displayMember={"status"}
                                                onItemSelected={() => this.viewModel.pageManager.refreshData()}
                                                items={this.viewModel.corporateActionEventsApiClient.getCorporateActionStatusListByCriteria(" ").then((arr) => arr.data.slice(0,15)
                                                .sort((x,y)=> x.status.localeCompare(y.status)))}
                                            />
                                        </Neo.FormGroup>
                                    </div>
                                </div>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchCorporateActionEvents}
                                    append={
                                        <Neo.Button className="btn-small" isSubmit variant="primary">
                                            <i className={`${this.viewModel.corporateActionEventSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />

                                        </Neo.Button>
                                    } />

                            </Neo.Form>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show:" }}>
                                <div className="horizontalScroll">
                                    {this.viewModel.pageManager.totalRecords > 0 &&
                                        <NeoGrid.Grid<CorporateActionEventLookup>>
                                            {(item, meta) => (
                                                <NeoGrid.RowGroup>
                                                    <NeoGrid.Row key={item.corporateActionEventID} className="twoRowsPerGridItem">
                                                        <NeoGrid.Column display={meta.broker} />
                                                        <NeoGrid.Column display={meta.instrument} />
                                                        <NeoGrid.Column display={meta.dateEvent} cellClassName="text-center" />
                                                        <NeoGrid.Column display={meta.rawEventType} />
                                                        <NeoGrid.Column display={meta.rawCorporateActionType} />
                                                        <NeoGrid.Column display={meta.rawExchange} />
                                                        <NeoGrid.Column display={meta.rawUnderlyingSecurityCode} />
                                                        <NeoGrid.Column display={meta.status} />
                                                    </NeoGrid.Row>
                                                    <NeoGrid.Row className="twoRowsPerGridItem">
                                                        <NeoGrid.Column display={meta.researcherComment} colSpan={4} />
                                                        <NeoGrid.Column display={meta.enactmentComment} colSpan={3} />
                                                        <NeoGrid.ButtonColumn className="text-center" label="Edit">
                                                            <Neo.Button
                                                            variant="primary" isOutline className="btn-small"
                                                            disabled={meta.status.value.replace(' ','') == this.viewModel.completedCorporateActionsStatus.replace(' ','')}
                                                            data-tip="Complete the action"
                                                            onClick={() => this.viewModel.showCompleteCorporateActionModal(item)}>
                                                            <i className="fa fa-flag"></i>
                                                            </Neo.Button>                                                                   
                                                            <Neo.Button
                                                                variant="primary" isOutline
                                                                disabled={meta.status.value.replace(' ','') == this.viewModel.completedCorporateActionsStatus.replace(' ','')}
                                                                className="btn-small"
                                                                data-tip="Edit the action"
                                                                onClick={() => this.viewModel.editCorporateActionEvent(item)}>
                                                                <i className="fa fa-edit"></i>
                                                            </Neo.Button>
                                                            <Neo.Button
                                                                variant="primary" isOutline className="btn-small"
                                                                disabled={meta.status.value.replace(' ','') == this.viewModel.completedCorporateActionsStatus.replace(' ','')}
                                                                data-tip="Delete the action"
                                                                onClick={() => this.viewModel.showDeleteCorporateActionModal(item)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Neo.Button>
                                                        </NeoGrid.ButtonColumn>
                                                    </NeoGrid.Row>
                                                </NeoGrid.RowGroup>
                                            )}
                                        </NeoGrid.Grid>
                                    }
                                </div>
                            </Neo.Pager>
                        </Neo.Card>
                    </>}
            </>
        );
    }
}